import { createAction } from 'redux-actions';

export const UPDATE_USER_COMPANIES =
  'glints/user/companies/UPDATE_USER_COMPANIES';

export const updateUserCompanies = createAction(UPDATE_USER_COMPANIES);
